import React, { useEffect, useState } from "react";

const QRCodePopup = ({ media, onSave, onClose }) => {

    const [name, setName] = useState("");
    const [qrType, setQrType] = useState("URL");
    const [value, setValue] = useState("");
    const [size, setSize] = useState(250);
    const [foregroundColor, setForegroundColor] = useState("#000000");
    const [backgroundColor, setBackgroundColor] = useState("#FFFFFF");
    const [showLabel, setShowLabel] = useState(false);
    const [duration, setDuration] = useState(30);

    useEffect(() => {

        if (media) {
            setName(media.name);
            setQrType(media.qrType || "URL");
            setValue(media.value || "");
            setSize(media.size || 250);
            setForegroundColor(media.foregroundColor || "#000000");
            setBackgroundColor(media.backgroundColor || "#FFFFFF");
            setShowLabel(media.showLabel || false);
            setDuration(media.duration || 30);
        }

    }, [media]);

    const handleSave = () => {

        onSave({
            id: media?.id || null,
            name,
            qrType,
            value,
            size,
            foregroundColor,
            backgroundColor,
            showLabel,
            duration
        });

    };

    return (

        <div className="popup-overlay">

            <div className="popup-content" style={{ width: 650 }}>

                <h2>{media ? "Edit QR Code" : "Add QR Code"}</h2>

                <div className="form-group">
                    <label>Name</label>
                    <input
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>QR Type</label>

                    <select
                        className="form-control"
                        value={qrType}
                        onChange={(e) => setQrType(e.target.value)}
                    >
                        <option>URL</option>
                        <option>Text</option>
                        <option>Email</option>
                        <option>Phone</option>
                        <option>SMS</option>
                        <option>WiFi</option>
                        <option>vCard</option>
                        <option>UPI</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Value</label>

                    <textarea
                        rows={4}
                        className="form-control"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>QR Size (px)</label>

                    <input
                        type="number"
                        className="form-control"
                        value={size}
                        onChange={(e) => setSize(Number(e.target.value))}
                    />
                </div>

                <div className="form-group">
                    <label>Foreground Color</label>
                    <input
                        type="color"
                        className="form-control"
                        value={foregroundColor}
                        onChange={(e) => setForegroundColor(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Background Color</label>
                    <input
                        type="color"
                        className="form-control"
                        value={backgroundColor}
                        onChange={(e) => setBackgroundColor(e.target.value)}
                    />
                </div>

                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={showLabel}
                        onChange={(e) => setShowLabel(e.target.checked)}
                    />

                    <label>&nbsp;Show Label</label>
                </div>

                <div className="form-group mt-3">
                    <label>Duration (seconds)</label>

                    <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e) => setDuration(Number(e.target.value))}
                    />
                </div>

                <div className="form-buttons">

                    <button
                        className="btn btn-success"
                        onClick={handleSave}>
                        Save
                    </button>

                    &nbsp;

                    <button
                        className="btn btn-primary"
                        onClick={onClose}>
                        Cancel
                    </button>

                </div>

            </div>

        </div>

    );

};

export default QRCodePopup;